import React from 'react'
import EditPageDocsGenerateModal from '../configuration/edit-page/EditPageDocsGenerateModal'
import FieldSelect from '../configuration/fields/FieldSelect';
import * as Row from '../layout/Row';
import ProjectStore from '../../store/projectStore';

export default class ProjectXlsSpecificationModal extends EditPageDocsGenerateModal {
    constructor(props) {
        super(props)

        this.state = {
            ...this.state,
            languageId: null,
            selectedSections: [],
            projectChecked: false,
        }
    }

    thenFetchModalData(response) {
        this.setState({
            model: response.data,
            selectedConfigurations: response.data.configurations.value.map(x => x.id),
            languageId: response.data.language.value,
            isLoading: false
        });
    }

    getDocumentationModalContentData() {
        return this.props.id
    }

    onLanguageChange = item => {
        this.setState({
            languageId: item
        })
    }

    onTechnicalSpecificationItemChange = item => {
        this.setState({
            technicalSpecification: item.value
        })
    }

    executeAction = (data) => {
        return this.configurationAPIService.generateXlsSpecification(data)
    }

    renderBody() {
        const languages = this.state.isLoading ? [] : this.state.model.language.items
        return (
            <div className="project-specification-for-order-processing-modal">
                <div className="text-muted" style={{paddingBottom: '0.5rem'}}>{__(this.getDescription())}</div>
                <Row.Container hasOuterGutter={false} className="flex-center-v" style={{paddingTop: '1rem'}}>
                    <Row.Column6>
                        <div className="text-muted">{__('Language')}</div>
                    </Row.Column6>
                    <Row.Column6>
                        <FieldSelect
                            items={languages}
                            value={this.state.languageId}
                            onChange={this.onLanguageChange}
                        />
                    </Row.Column6>
                </Row.Container>
                <Row.Container hasOuterGutter={false} className="flex-center-v" style={{paddingTop: '1rem'}}>
                    <Row.Column12>
                        {this.renderConfigurations()}
                    </Row.Column12>
                </Row.Container>
            </div>
        )
    }

    getDescription = () => 'Project specification for order processing';

    renderConfigurations = () => (
        <div>
            <div className="text-muted" style={{paddingBottom: '0.5rem'}}>{__('Configurations')}</div>
            <div className="configurations">
                {this.state.model.configurations.value.map(x => (
                    <div className="configuration">
                        <input id={x.id} type="checkbox" checked={this.state.selectedConfigurations.includes(x.id)}
                               onChange={() => this.onConfigurationClick(x.id)}/>
                        <label htmlFor={x.id}>{x.name}</label>
                        {x.canSetProductSerialNumber && this.renderProductSerialNumber(x)}
                    </div>
                ))}
            </div>

        </div>
    )

    onConfigurationClick = id => {
        this.setState(prev => ({
            selectedConfigurations: _.xor(prev.selectedConfigurations, [id])
        }))
    }

    renderProductSerialNumber = configuration => {
        if (configuration.productSerialNumber) {
            return (
                <span
                    className="configuration-product-serial-number">{__('S/N')}: {configuration.productSerialNumber}</span>
            )
        } else {
            return (
                <span className="configuration-product-serial-number --missing">{__('S/N: not available')}</span>
            )
        }
    }

    buildPostModel() {
        let projects = this.state.projectChecked ? [2] : [];
        return {
            id: this.props.id,
            type: 'Substation',
            factoryDiscount: ProjectStore.formModel.summary.factoryDiscountValue.value,
            outcomes: [128],//??
            language: this.state.languageId,
            projects: projects,
            configurations: this.state.selectedConfigurations.map(x => ({
                id: x
            }))
        }
    }

    getDocumentType() {
        return 'Project';
    }
}